
import NavbarMio from '../components/NavbarMio'
import HistorialComisionesAdmin from './HistorialComisionesAdmin'

export default function ComisionAdmin() {
    return (
        <div className="row">
            <div className="d-flex justify-content-center mt-4 mb-5">
                <div className="col-md-8 col-12">
                    <div className="card">


                        <div className="card-header">
                            <NavbarMio ruta='comision' />
                        </div>


                        <div className="card-body">

                            {/* tabla */}
                            <HistorialComisionesAdmin fromAdmin={true}/>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
